import { types } from '../../types';

const setGetListMessangerAction = (payload) => {
  return {
    type: types.messanger.SET_LIST_MESSANGER,
    payload,
  }
}

const setGetViewMessangerAction = (payload) => {
  return {
    type: types.messanger.SET_VIEW_MESSANGER,
    payload
  }
}
export {
  setGetListMessangerAction as SetGetListMessangerAction,
  setGetViewMessangerAction as SetGetViewMessangerAction
}
